export default function () {
  this.doLoad()
}



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/components/overview/resources/mounted.js